const firebaseConfig = {
    apiKey: "AIzaSyBjRSw06QLYsksLT1zeLtjboDxq1DAqckg",
    authDomain: "teaching-platform-79dd5.firebaseapp.com",
    databaseURL: "https://teaching-platform-79dd5.firebaseio.com",
    projectId: "teaching-platform-79dd5",
    storageBucket: "teaching-platform-79dd5.appspot.com",
    messagingSenderId: "1074831303369",
    appId: "1:1074831303369:web:ff33ea571942113f642318",
    measurementId: "G-277C85EVR1"
};

export default firebaseConfig;